/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Loader } from 'semantic-ui-react';

import DashboardList from './DashboardList';
import ManageDashboard from './ManageDashboard';
import {
  getDashboards,
  removeDashboard
} from '../../services/DashboardService';
import { getTagsForDashboards } from '../../services/TagService';
import './LookerDashboard.css';

class LookerDashboard extends Component {
  state = {
    section: 'search',
    dashboards: null,
    dashboardsTags: null,
    loading: false,
    tagCategories: ['dashboard_type', 'funding']
  };

  componentDidMount() {
    this.props.setSectionTitle('Looker Dashboards');
    this.props.saveGTMEvent('Looker Dashboard', 'Alexia');
    this.getDashboards();
  }

  getDashboards = () => {
    try {
      this.setState({ loading: true });
      getDashboards().then((dashboards) => {
        const dashboardIds = dashboards.dashboards.map((dashboard) => {
          return dashboard.id;
        });
        getTagsForDashboards(dashboardIds).then((tagsForDashboards) => {
          const dashboardTagsRows = [];

          tagsForDashboards.dashboardsTags.forEach((row) => {
            if (row.length > 0) {
              dashboardTagsRows.push(row);
            }
          });

          this.setState({
            dashboards: dashboards.dashboards,
            loading: false,
            dashboardsTags: dashboardTagsRows
          });
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  newDashboard = () => {
    this.setState({
      section: 'newDashboard',
      dashboardToEdit: '',
      dasboardsTagsToEdit: ''
    });
  };

  searchPage = () => {
    this.setState({ section: 'search' });
    this.getDashboards();
  };

  editDashboard = async (id) => {
    const dashboardToEdit = this.state.dashboards.find(
      (dashboard) => dashboard.id === id
    );

    const dashboardsTagsToEdit = this.state.dashboardsTags.filter(
      (row) => row[0].dashboard_id === id
    )[0];

    this.setState({
      section: 'newDashboard',
      dashboardToEdit,
      dashboardsTagsToEdit
    });
  };

  deleteDashboard = async (id) => {
    await removeDashboard(id);
    this.getDashboards();
  };

  render() {
    const {
      section,
      loading,
      dashboardToEdit,
      dashboardsTagsToEdit,
      dashboards,
      dashboardsTags,
      tagCategories
    } = this.state;
    return (
      <div className="container">
        {section === 'search' ? (
          loading ? (
            <div className="dashboard-builder-loading">
              <span>
                {' '}
                <Loader inline className="active" /> Loading...{' '}
              </span>
            </div>
          ) : (
            <DashboardList
              dashboards={dashboards}
              dashboardsTags={dashboardsTags}
              newDashboard={this.newDashboard}
              deleteDashboard={this.deleteDashboard}
              editDashboard={this.editDashboard}
              tagCategories={tagCategories}
            />
          )
        ) : null}
        {section === 'newDashboard' ? (
          <ManageDashboard
            searchPage={this.searchPage}
            dashboardToEdit={dashboardToEdit}
            dashboardsTagsToEdit={dashboardsTagsToEdit}
          />
        ) : null}
      </div>
    );
  }
}

export default LookerDashboard;



// WEBPACK FOOTER //
// ./src/screens/LookerDashboard/LookerDashboard.js